// Chakra imports
import {
  useDisclosure,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";
// Layout components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { MainLayout } from "./main";
// Custom Chakra theme

import "./styles/style.css";
import { USER_SIDEBAR_MENU, LOGO_TEXT } from "constants/user-profile";
import { STYLE_PANEL } from "constants/AppConstants";
import * as utils from "utils";
import { useTranslation } from "react-i18next";
import { userSignOut } from "appRedux/actions/Auth";
import Footer from "components/Footer/Footer";

export const UserProfile = (props) => {
  const { children, ...rest } = props;
  // states and functions
  const [fixed, setFixed] = useState(false);
  const [alertTimeout, setAlertTimeout] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const authStore = useSelector((store) => store.auth, shallowEqual);
  const { tokenInfo, loggedTime } = authStore;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (tokenInfo) {
      const expirationTime = Number(loggedTime) + Number(tokenInfo?.timeout);
      const timer = setInterval(() => {
        if (utils.getCurrentTimeInSecond() > expirationTime - 10) {
          setAlertTimeout(true);
          clearInterval(timer);
        }
      }, 1000);
      

      return () => clearInterval(timer);
    }
  }, []);

  const handleSignOut = () => {
    dispatch(userSignOut());
  };

  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].views);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (window.location.href.indexOf(routes[i].path) !== -1) {
          return routes[i];
        }
      }
    }
    return activeRoute;
  };

  return (
    <MainLayout>
      <Sidebar
        routes={USER_SIDEBAR_MENU}
        logoText={LOGO_TEXT}
        position="fixed"
        top="0"
        right="0"
        h="100vh"
        overflowY="auto"
        {...rest}
      />
      <Box
        h="100vh"
        overflow="hidden"
        mr={{ base: "16px", lg: "275px" }}
        ml={4}
      >
        <AdminNavbar
          onOpen={onOpen}
          logoText={LOGO_TEXT}
          fixed={fixed}
          brandText={getActiveRoute(USER_SIDEBAR_MENU)}
          {...rest}
        />
        <br />
        <Box h="calc(100vh - 90px)" overflowY="auto" overflowX="hidden">
          {children}
        </Box>
        <Footer />
      </Box>

      <Modal closeOnOverlayClick={false} isOpen={alertTimeout}>
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent bg={"modal_bg"}>
          <ModalHeader color={"modal_text"}>
            {t("Profile.Field.label.token.expired.title")}
          </ModalHeader>
          <ModalBody pb={6}>{t("Profile.Field.label.token.expired")}</ModalBody>

          <ModalFooter>
            <Button
              bg={"button_teal_bg"}
              color={"button_teal_color"}
              _hover={{ bg: "button_teal_hover" }}
              mr={3}
              borderRadius={8}
              onClick={handleSignOut}
            >
              {t("Profile.Field.label.token.expired.button")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </MainLayout>
  );
};
